export const bottleTypeMap = {
    formula: 'Formula',
    breast_milk: 'Breast Milk',
    cows_milk: `Cow's Milk`,
    other: 'Other'
  };
  
  export default [
    { id: 'not_applicable', name: 'N/A' },
    { id: 'formula', name: 'Formula' },
    { id: 'breast_milk', name: 'Breast Milk' },
    { id: 'cows_milk', name: `Cow's Milk` },
    { id: 'other', name: 'Other' }
  ];
  